import { FormattedMessage } from 'react-intl';
import React from 'react';
import Alert from './UI/Alert';
import mailSentLogo from '../assets/img/undraw_Mail_sent.svg';

function MessageAlreadySent({
  isSuccess,
  message,
  inLocalStorage,
}: {
  isSuccess: boolean;
  message: string;
  inLocalStorage: boolean;
}) {
  if ((isSuccess && message.length > 0) || inLocalStorage) {
    return (
      <Alert>
        <img src={mailSentLogo} alt="" width={100} />
        <br />
        <br />
        {message || (
          <FormattedMessage id="contact.message-already-sent-today" />
        )}
        <br />
        <br />
        <FormattedMessage id="contact.message-sent-wait" />
      </Alert>
    );
  }
  return null;
}

export default MessageAlreadySent;
